"use client";

import { ArrowRight, ShieldCheck, FileText, Search } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Compliancedocumentresources() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const cardsReveal = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    number: "01",
    title: "法規合規性",
    Icon: ShieldCheck,
    body: "我們確保所有進口醫療技術嚴格遵守國際安全標準與當地法規要求，降低全球合作夥伴的風險。",
    italic: "安全是我們的基本承諾。",
    offset: "md:translate-y-0"
  }, {
    number: "02",
    title: "文件支援",
    Icon: FileText,
    body: "我們的團隊提供全面的技術文件、臨床評估報告與認證支援，以簡化您當地市場的註冊程序。",
    italic: "每一個細節都透明。",
    offset: "md:-translate-y-12"
  }, {
    number: "03",
    title: "臨床評估",
    Icon: Search,
    body: "我們對所有產品進行嚴格的臨床評估，確保只有高價值、臨床證明的技術才能到達全球醫療專業人員手中。",
    italic: "基於證據的醫療卓越。",
    offset: "md:translate-y-12"
  }];
  return <section data-section-id="3504" id="compliancedocumentresources" className="bg-white text-slate-900 py-24 md:py-36 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {}
        <div ref={header.ref} className={`text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default font-bold tracking-[0.3em] uppercase mb-6 text-teal-600" style={{
          fontSize: "11px"
        }}>
            我們的標準
          </p>
          <h2 className="font-default font-extrabold text-5xl md:text-7xl lg:text-8xl tracking-tight text-slate-900 leading-[0.95] mb-6">
            合規性與品質
            <span className="text-teal-600">。</span>
          </h2>
          <p className="font-default italic text-lg text-slate-600 max-w-xl mx-auto">
            通過嚴格的全球標準確保信任。
          </p>
        </div>

        {}
        <div ref={cardsReveal.ref} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-8">
          {pillars.map((pillar, i) => {
          const Icon = pillar.Icon;
          return <div key={i} data-index={i} className={`group transition-all duration-1000 ease-out ${pillar.offset} ${cardsReveal.isVisible ? "opacity-100" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="relative h-full min-h-[520px] p-10 flex flex-col rounded-lg border border-slate-200 backdrop-blur-sm transition-all duration-500 ease-out group-hover:-translate-y-2 shadow-md" style={{
              backgroundColor: "white"
            }}>
                  {}
                  <div className="absolute inset-0 rounded-lg border-2 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none border-teal-500" />

                  {}
                  <div className="flex items-center justify-between mb-10">
                    <span className="font-default font-bold tracking-widest uppercase text-teal-700" style={{
                  fontSize: "13px"
                }}>
                      {pillar.number}
                    </span>
                  </div>

                  {}
                  <div className="mb-10">
                    <Icon className="w-16 h-16 transition-transform duration-500 group-hover:scale-110 text-teal-600" strokeWidth={1.5} />
                  </div>

                  {}
                  <h3 className="font-default font-extrabold text-3xl md:text-4xl text-slate-900 mb-5 tracking-tight leading-tight">
                    {pillar.title}
                  </h3>

                  {}
                  <div className="h-[2px] w-6 mb-6 bg-teal-600" />

                  {}
                  <p className="font-default font-light text-[17px] leading-relaxed text-slate-800 mb-2">
                    {pillar.body}
                  </p>
                  <p className="font-default italic text-[17px] leading-relaxed text-slate-600 mb-10">
                    {pillar.italic}
                  </p>

                  {}
                  <div className="mt-auto pt-6">
                    <Button asChild variant="ghost" className="h-auto p-0 font-default font-bold tracking-widest uppercase text-xs hover:bg-transparent group/btn text-teal-700">
                      <Link to="/CompliancePage">
                        Learn More
                        <ArrowRight className="ml-2 w-4 h-4 transition-transform duration-300 group-hover/btn:translate-x-1" />
                      </Link>
                    </Button>
                  </div>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}